import { Box, Typography } from '@mui/material'
import { FC } from 'react'
import { getPxAsRem } from 'shared/utils'
import { ResultItem } from './ResultItem'
import { EntityType, SearchResultItem } from './types'

interface ResultColumnProps {
    title: string
    type: EntityType
    items: SearchResultItem[]
    onSelect: () => void
    highlightedRow?: number
}

export const ResultColumn: FC<ResultColumnProps> = ({
    title,
    type,
    items,
    onSelect,
    highlightedRow,
}) => {
    return (
        <Box>
            <Typography
                variant="caption"
                color="text.secondary"
                fontWeight={600}
                sx={{
                    display: 'block',
                    padding: getPxAsRem(8, 12, 4),
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                }}
            >
                {title}
            </Typography>
            {items.length === 0 ? (
                <Box padding={getPxAsRem(8, 12)}>
                    <Typography variant="body2" color="text.disabled">
                        No results
                    </Typography>
                </Box>
            ) : (
                items.map((item, index) => (
                    <ResultItem
                        key={item.id}
                        type={type}
                        name={item.name}
                        subtitle={item.subtitle}
                        path={item.path}
                        onSelect={onSelect}
                        isHighlighted={index === highlightedRow}
                    />
                ))
            )}
        </Box>
    )
}
